export class MailingListHistory {
  public dateChange: Date;
  public mailingList: boolean;

  public static fromJson(json: object): MailingListHistory {
    const item = new MailingListHistory();
    Object.assign(item, json);
    item.dateChange = new Date(json['dateChange']);
    return item;
  }

}
